export enum PlatformAuthMethod {
    OAuth = 'OAUTH',
    ApiKey = 'API_KEY',
    UsernamePassword = 'USERNAME_PASSWORD',
    Other = 'OTHER',
}
